import {
  getCurrentAuthState,
  setAppSessionJwts,
} from '~/atoms/AuthenticationState'
import { isAccessTokenExpired } from '~/utils/functions'

/**
 * Validates authentication state on app startup.
 * Clears expired tokens to prevent initialization loops.
 * Should be called before any service initialization.
 */
export const validateStartupAuth = (): boolean => {
  const authState = getCurrentAuthState()
  const accessToken = authState.appSessionJwts?.access_token
  const refreshToken = authState.appSessionJwts?.refresh_token

  if (!accessToken) {
    console.info('No access token on startup')
    return false
  }

  if (isAccessTokenExpired(accessToken)) {
    // If we have a refresh token, let the 401 interceptor handle the refresh
    // Only clear auth if there's no refresh token available
    if (!refreshToken) {
      console.warn('Expired token with no refresh token, clearing auth state')
      setAppSessionJwts(undefined)
      return false
    }
    console.info(
      'Expired access token detected, will be refreshed on first API call',
    )
    return true // Allow app to start, token will be refreshed automatically
  }

  return true
}
